import React from 'react';
import styled from 'styled-components';

import Container from './container';

const SectionStyle = styled.section`
	padding: 6rem 0;
	color: ${(p) => (p.bg === 'white' ? p.theme.color.dark : '#fff')};
	background-color: ${(p) => {
		if (p.bg === 'green') {
			return p.theme.color.green;
		} else if (p.bg === 'teal') {
			return p.theme.color.teal;
		} else if (p.bg === 'dark') {
			return p.theme.color.dark;
		} else if (p.bg === 'purple') {
			return p.theme.color.purple;
		} else if (p.bg === 'white') {
			return '#fff';
		} else {
			return p.theme.color.dark;
		}
	}};
	@media all and (max-width: 768px) {
		padding: 4rem 0;
	}
	@media all and (max-width: 500px) {
		padding: 3rem 0;
	}
`;

const Section = ({ children, bg, id, className }) => {
	return (
		<SectionStyle bg={bg} className={className} id={id}>
			<Container>{children}</Container>
		</SectionStyle>
	);
};

export default Section;
